import { render, staticRenderFns } from "./verify-otp.vue?vue&type=template&id=2e7f5c6a"
import script from "./verify-otp.vue?vue&type=script&lang=js"
export * from "./verify-otp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports